import { NavigateFunction } from 'react-router-dom';
import { LanguageOutlined } from '@mui/icons-material';

import { icons } from '@/assets';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { ROLES } from '@/components/security/AppRoles';

export const ADMINISTRATION_PATH = '/administration';
export const ADMINISTRATION_PAGE_NAME = 'Administración';

export const administrationMenuItems = [
  {
    id: 'apps-versions',
    label: 'Versiones de aplicaciones',
    route: '/apps-versions',
    icon: icons.settingsCatalogs,
    permission: ROLES.BUSINESS.admin,
  },
  {
    id: 'institutional-web',
    label: 'Web institucional',
    route: '/institutional-web',
    icon: LanguageOutlined,
    permission: ROLES.BUSINESS.admin,
    hidden: false,
  },
].filter((item) => !item.hidden);

export const administrationPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', onClick: () => navigate('/') }];

export const administrationChildrenBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...administrationPageBreadcrumbs(navigate),
  {
    label: ADMINISTRATION_PAGE_NAME,
    onClick: () => navigate(ADMINISTRATION_PATH),
  },
];
